import styled from "styled-components";
import AppBar from "@mui/material/AppBar";
import { Box, Button, List, MenuItem } from "@mui/material";
import type { Theme } from "../../../constants/themeConstants";
import { Link } from "react-router-dom";
import { Menu } from "@mui/material";

export const HeaderContainer = styled( AppBar )`
  && {
    padding: 0;
    background-color: ${ ( props ) => ( props.theme as Theme )?.colors?.white };
    @media (min-width: 600px) {
      .MuiContainer-root {
        padding: 16px 80px;
      }

      .MuiToolbar-root {
        justify-content: space-between;
      }
    }
  }
`;

export const LogoContainer = styled.div``;

export const Logo = styled.picture`
  width: auto;
`;

export const DesktopMenu = styled( List )`
  && {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    gap: 16px;
    .MuiListItem-root {
      width: min-content;
      padding: 0;
      align-items: flex-start;
    }
  }
`;

export const DesktopMenuItem = styled( Link )`
  && {
    color: ${ ( props ) => ( props.theme as Theme )?.colors?.textColor };
    font-weight: 400;
    font-size: 16px;

    display: flex;
    flex-direction: column;
    justify-content: start;
    flex-wrap: nowrap;
    gap: 6px; //8px;
    white-space: nowrap;
    padding-top: 12px;

    text-decoration: none;

    span {
      padding: 0 8px;
    }
  }
`;

export const DropdownButton = styled( Button )`
  && {
    color: ${ ( props ) => ( props.theme as Theme )?.colors?.textColor };
    font-weight: 400;
    font-size: 16px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    letter-spacing: normal;

    padding: 12px 0 0;
    text-decoration: none;
    text-transform: initial;
    align-items: flex-start;
    gap: 0;

    .MuiButton-icon {
      padding: 0;
      margin: 0;
    }

    &:hover,
    &:focus,
    &.Mui-focusVisible {
      background-color: ${ ( props ) => ( props.theme as Theme )?.colors?.white };
    }

    &:focus-visible,
    &:focus {
      outline: none;
    }

    .MuiTouchRipple-root {
      display: none;
    }
  }
`;

export const DropdownButtonTitle = styled( Box )`
  && {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 6px; //8px;
    text-decoration: none;
    text-transform: initial;

    span {
      line-height: 20px;
      padding: 0 8px;
    }
  }
`;

export const DropdownItem = styled( MenuItem )`
  && {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;

    max-width: 160px;
    flex-grow: 1;

    gap: 6px; //8px;
    text-decoration: none;
    text-transform: initial;
    padding: 4px 5px 4px 12px;

    a {
      color: ${ ( props ) => ( props.theme as Theme )?.colors?.textColor };
      &:hover {
        color: ${ ( props ) => ( props.theme as Theme )?.colors?.hoverTextColor };
      }
      text-wrap: auto;
    }
    &,
    &:hover,
    &:focus,
    &.Mui-focusVisible {
      background-color: ${ ( props ) => ( props.theme as Theme )?.colors?.white };
    }

    &:focus-visible,
    &:focus {
      outline: none;
    }

    .MuiTouchRipple-root {
      display: none;
    }
  }
`;

export const DropdownNav = styled( Menu )`
  && .MuiPaper-root {
    margin-top: 16px;
    border-radius: 0;
    max-width: 640px;
    border-top: 2px solid ${ ( { theme } ) => ( theme as Theme ).colors.secondary };
    background-color: ${ ( props ) => ( props.theme as Theme )?.colors?.white };
  }

  && .MuiList-root {
    display: grid;
    grid-template-rows: repeat(3, 1fr);

    grid-auto-flow: column;
  } 
`;
